<template>
  <div>
    <van-nav-bar :style="{ background: backColor, border: backColor }">
      <template #title>
        <span :style="{ color: textColor }">{{ title }}</span>
      </template>
      <template #left>
        <van-image class="icon" fit="contain" :src="icon" @click="goback" />
      </template>
      <template #right v-if="rightbg">
        <img class="right" :src="rightbg" @click="goSearch" />
      </template>
    </van-nav-bar>
  </div>
</template>
  
  <script>
export default {
  name: "navBarr",
  props: {
    icon: String,
    textColor: String,
    backColor: String,
    rightbg: String,
    rightColor: String,
    backClick: Number,
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
  },
  methods: {
    goback() {
      this.closePage();
    },
    closePage() {
        console.log('点击了')
      let params = "调用";
      this.$bridge.callhandler("closePage", params, (data) => {
        // 处理返回数据
      });
    },
    goSearch() {
      this.$router.push({ path: "/search" });
    },
  },
};
</script>
  
  <style>
.van-nav-bar::after {
  border: none;
}
</style>
  <style scoped>
.icon {
  width: 20px;
  height: 35px;
}
.right {
  width: 45px;
}
</style>